import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';
import { Id } from 'convex/_generated/dataModel';

type HarvestQueryArgs = {
  gardenId: Id<'gardens'>;
  startDate: string;
  endDate: string;
};

export function useCreateHarvest({ gardenId, startDate, endDate }: HarvestQueryArgs) {
  const queryArgs = { gardenId, startDate, endDate };

  return useMutation(api.harvest.mutations.createHarvest).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.harvest.queries.getHarvestsForGarden, queryArgs);
      if (current === undefined) return;

      localStore.setQuery(api.harvest.queries.getHarvestsForGarden, queryArgs, [
        {
          _id: `__opt_${Date.now()}` as unknown as Id<'harvests'>,
          _creationTime: Date.now(),
          userId: '' as unknown as Id<'users'>,
          gardenId: args.gardenId,
          plantId: args.plantId,
          harvestDate: args.harvestDate,
          measureType: args.measureType,
          amount: args.amount,
          weightUnit: args.measureType === 'weight' ? args.weightUnit : undefined,
        },
        ...current,
      ]);
    }
  );
}

export function useUpdateHarvest({ gardenId, startDate, endDate }: HarvestQueryArgs) {
  const queryArgs = { gardenId, startDate, endDate };

  return useMutation(api.harvest.mutations.updateHarvest).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.harvest.queries.getHarvestsForGarden, queryArgs);
      if (current === undefined) return;

      localStore.setQuery(
        api.harvest.queries.getHarvestsForGarden,
        queryArgs,
        current.map((item) =>
          item._id === args.harvestId
            ? {
                ...item,
                gardenId: args.gardenId,
                plantId: args.plantId,
                harvestDate: args.harvestDate,
                measureType: args.measureType,
                amount: args.amount,
                weightUnit: args.measureType === 'weight' ? args.weightUnit : undefined,
              }
            : item
        )
      );
    }
  );
}

export function useDeleteHarvest({ gardenId, startDate, endDate }: HarvestQueryArgs) {
  const queryArgs = { gardenId, startDate, endDate };

  return useMutation(api.harvest.mutations.deleteHarvest).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.harvest.queries.getHarvestsForGarden, queryArgs);
      if (current === undefined) return;

      localStore.setQuery(
        api.harvest.queries.getHarvestsForGarden,
        queryArgs,
        current.filter((item) => item._id !== args.harvestId)
      );
    }
  );
}
